"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _icons = require("./assets/icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Define the props interface for the component

var CheckMark = function CheckMark(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$checkMarkClass = _ref.checkMarkClass,
    checkMarkClass = _ref$checkMarkClass === void 0 ? "" : _ref$checkMarkClass,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 24 : _ref$width,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#000000" : _ref$color,
    _ref$alignTop = _ref.alignTop,
    alignTop = _ref$alignTop === void 0 ? false : _ref$alignTop;
  var checkMarkColor = color === "boost" && "#8E6DF7" || color === "white" && "#FFFFFF" || color;
  var checkMarkStyle = {
    width: width,
    height: width,
    color: checkMarkColor
  };
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex ".concat(alignTop ? "items-start" : "items-center", " ").concat(className)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: checkMarkClass
  }, /*#__PURE__*/_react["default"].createElement(_icons.CheckIcon, checkMarkStyle)), children);
};
var _default = exports["default"] = CheckMark;